module.exports = __webpack_public_path__ + "img/6.0a59833a.jpg";